import { CHECKOUT_RESERVATION_TOKEN_SESSIONSTORAGE_KEY } from './constants'

function getSessionStorage(): Storage | null {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

export function getStoredReservationToken(): string | null {
    return getSessionStorage()?.getItem(CHECKOUT_RESERVATION_TOKEN_SESSIONSTORAGE_KEY) ?? null
}

export function setStoredReservationToken(token: string): void {
    getSessionStorage()?.setItem(CHECKOUT_RESERVATION_TOKEN_SESSIONSTORAGE_KEY, token)
}

export function clearStoredReservationToken(): void {
    getSessionStorage()?.removeItem(CHECKOUT_RESERVATION_TOKEN_SESSIONSTORAGE_KEY)
}
